import TemplateView from '../../../../js/TemplateView'
import {ICalTabType, LEARN_MORE_URL} from '../constants'
import Button from '../../../../js/components/Button'
import messageResource from '../../../../js/messageResource'
import Link from '../../../../js/components/Link'

export default class NoFeedsArea extends TemplateView {

    constructor({
        onCreateButtonClick,
        onExportButtonClick,
    }) {
        super()

        this.state = {
            mode: ICalTabType.USER_FEEDS,
            allFeedsAvailable: false,
        }

        this.callbacks = {
            onCreateButtonClick,
            onExportButtonClick,
        }

        this.onAnyStatePropertyChanged(['mode', 'allFeedsAvailable'], () => {
            this.$allFeedsContent.toggle(this.state.mode === ICalTabType.ALL_FEEDS && this.state.allFeedsAvailable)
            this.$sharedFeedsContent.toggle(this.state.mode === ICalTabType.USER_FEEDS || !this.state.allFeedsAvailable)
        })
    }

    templateHtml() {
        return `<div class='noFeedsContent'>
                    <div class='icon'/>
                    <div class='allFeedsContent content'>
                        <div class='description'>
                            <div class='commonText'>
                                <%=descriptionFirstPart%>
                            </div>
                            <div class='specialText'>
                                <%=allFeedsSpecialText%>
                                <span class='learnLink'/>
                            </div>
                        </div>
                        <div class='buttonsArea'>
                            <div class='button createButton'/>
                            <div class='buttonsSeparator'>
                                <%=buttonsSeparatorText%>
                            </div>
                            <div class='button exportButton'/>
                        </div>
                    </div>
                    <div class='sharedFeedsContent content'>
                        <div class='description'>
                            <div class='commonText'>
                                <%=descriptionFirstPart%>
                            </div>
                            <div class='specialText'>
                                <%=sharedFeedsSpecialText%>
                            </div>
                        </div>
                        <span class='learnLink'/>
                    </div>
                </div>`
    }

    messageKeys() {
        return {
            descriptionFirstPart: 'icalendar.page.feeds.empty.part1',
            allFeedsSpecialText: 'icalendar.page.feeds.empty.part2.all',
            sharedFeedsSpecialText: 'icalendar.page.feeds.empty.part2.user',
            buttonsSeparatorText: 'common.or',
        }
    }

    afterRender() {
        this.$allFeedsContent = this.find('.allFeedsContent')
        this.$sharedFeedsContent = this.find('.sharedFeedsContent')

        new Link({
            text: messageResource.getMessage('icalendar.page.feeds.empty.learn'),
            extraClass: 'learnMore',
            reference: LEARN_MORE_URL,
        }).init(this.$allFeedsContent.find('.learnLink'))

        new Link({
            text: messageResource.getMessage('icalendar.page.feeds.empty.learn'),
            extraClass: 'learnMore',
            reference: LEARN_MORE_URL,
        }).init(this.$sharedFeedsContent.find('.learnLink'))

        new Button({
            label: messageResource.getMessage('icalendar.page.buttons.create'),
            withPlusIcon: true,
            onClickCb: this.callbacks.onCreateButtonClick,
        }).init(this.find('.createButton'))

        new Button({
            label: messageResource.getMessage('icalendar.page.buttons.export'),
            withPlusIcon: true,
            onClickCb: this.callbacks.onExportButtonClick,
        }).init(this.find('.exportButton'))

        this.renderInitialState()
    }
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/NoFeedsArea.js